import React from 'react';

const ErrorPage = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1>404 - Pagina no encontrada</h1>
        </div>
    );
};

export default ErrorPage;